import firebase from 'firebase/app'
import 'firebase/auth'

/**
 * set state change observer in application initialize phase
 */
export const setOnStateChange = (onSignedIn: (user: firebase.User) => void, onSignedOut: () => void) => {
  firebase.auth().onAuthStateChanged((user) => (user ? onSignedIn(user) : onSignedOut()))
}

export const registerAuthStateChangedCallback = (callbackFunction: (user) => any) => {
  firebase.auth().onAuthStateChanged(callbackFunction)
}

export const retrieveLoginStateWithWait = async (waitMaxMSec = 4000) => {
  // AuthCheck, 250ms毎に, 4秒くらいまで回す,
  const waitMSec = 250
  const loopMax = waitMaxMSec / waitMSec
  for (let i = 0; loopMax > i; i++) {
    const user = firebase.auth().currentUser
    if (user) {
      return user
    }
    await new Promise((resolve) => setTimeout(resolve, waitMSec))
  }
}

/**
 * create user
 */
export const createUserWithEmailAndPassword = async (
  email: string,
  password: string,
): Promise<[firebase.auth.UserCredential, firebase.auth.Error]> => {
  return new Promise((resolve) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((user) => resolve([user, null]))
      .catch((error) => resolve([null, error]))
  })
}

/**
 * before signin
 */
export const signInWithEmailAndPassword = async (
  email: string,
  password: string,
): Promise<[firebase.auth.UserCredential, firebase.auth.Error]> => {
  const [user, error] = await new Promise((resolve) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((user) => resolve([user, null]))
      .catch((error: firebase.auth.Error) => resolve([null, error]))
  })
  return [user, error]
}
export const signIn = async (email: string, password: string): Promise<firebase.auth.UserCredential> => {
  const [user, error] = await signInWithEmailAndPassword(email, password)
  if (user) {
    return user
  }
  throw error
}

/**
 * after signin
 */
export const getUser = (): firebase.User => {
  return firebase.auth().currentUser
}

export const signOut = async () => {
  try {
    await firebase.auth().signOut()
  } catch (e) {
    console.error(`[lib/firebaseAuth] Error signOut() await firebase.auth().signOut()`)
    console.error(e)
  }
}

export default {
  setOnStateChange,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  getUser,
  signOut,
  signIn,
  registerAuthStateChangedCallback,
  firebase
}
